<template>
    <div class="modal modal-slide-in chat-modal fade" :id="id">
        <div class="modal-dialog bg-white w-50">
            <button type="button" @click="closeModal(`#${id}`)" class="close" data-dismiss="modal" aria-label="Close">×</button>
            <div class="modal-header">
                <h5 class="modal-title d-flex align-items-center">
                    {{ localizationStore.translate('chat.sidebar.modal.title') }}
                    <img class="w-10 ml-50" :src="settingStore.favicon" alt="creditfixrr">
                </h5>
            </div>
            <div class="modal-body p-0 h-100">
                <div class="chat-app-window">
                    <div class="active-chat">
                        <div class="user-chats">
                            <div class="chats">
                                <div v-if="chatStore.conversations.isLoading" class="d-flex align-items-center justify-content-center">
                                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    <span class="ml-25 align-middle">Loading...</span>
                                </div>
                                <div
                                    v-if="chatStore.conversations.data.length > 0"
                                    v-for="conversation in chatStore.conversations.data"
                                    class="chat"
                                    :class="{ 'chat-left': conversation.sender_id == 0 }"
                                >
                                    <div class="chat-avatar">
                                        <span class="avatar box-shadow-1 cursor-pointer">
                                            <img
                                                src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg"
                                                alt="avatar"
                                                height="36"
                                                width="36"
                                            />
                                        </span>
                                    </div>
                                    <div class="chat-body">
                                        <div class="chat-content">
                                            <vue-feather :data-clipboard-text="conversation.message" class="copy-message float-right" type="copy" size="14" />
                                            <p v-html="conversation.message"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row match-height" v-else>
                                    <div class="col-12">
                                        <vue-feather class="mx-auto" type="book-open" size="20" />
                                        <h3 class="text-center">
                                            Examples
                                        </h3>
                                        <div class="card shadow-none bg-transparent border-primary mb-50">
                                            <div class="card-body p-50">
                                                <p @click="chatStore.message = 'Write me a dispute letter to Amex using this account 45353XXXXX'" class="p-cursor card-text">
                                                    "Write me a dispute letter to Amex using this account 45353XXXXX" <vue-feather type="arrow-right" size="14" />
                                                </p>
                                            </div>
                                        </div>
                                        <div class="card shadow-none bg-transparent border-primary mb-50">
                                            <div class="card-body p-50">
                                                <p @click="chatStore.message = 'What is 15 USC 1666b for late payments'" class="p-cursor card-text">
                                                    "What is 15 USC 1666b for late payments" <vue-feather type="arrow-right" size="14" />
                                                </p>
                                            </div>
                                        </div>
                                        <div class="card shadow-none bg-transparent border-primary mb-50">
                                            <div class="card-body p-50">
                                                <p @click="chatStore.message = 'How to write a Dispute Letter'" class="p-cursor card-text">
                                                    "How to write a Dispute Letter" <vue-feather type="arrow-right" size="14" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="chat-app-form" action="javascript:void(0);">
                            <div class="input-group input-group-merge form-send-message">
                                <input v-model="chatStore.message" type="text" class="form-control message" placeholder="Type your message i.e 'Write me a dispute letter to Amex using this account 45353XXX'" />
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary mx-1"
                                :key="chatStore.sendButtonKey"
                                id="chat-send-message"
                                @click.once="sendMessage()"
                            >
                                <template v-if="chatStore.isSending">
                                    <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>
                                    <vue-feather type="send" size="14" />
                                </template>
                                <b-popover
                                    target="chat-send-message"
                                    placement="top"
                                    triggers="hover"
                                    :html="true"
                                >
                                    <template #title>
                                        {{ localizationStore.translate("chat.pricing.title") }}
                                    </template>
                                    <div class="row">
                                        <div class="col-12">
                                            <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('chat') }) }}
                                            </p>
                                            <p v-else>
                                                {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                            </p>
                                        </div>
                                    </div>
                                </b-popover>
                            </button>
                            <button
                                data-toggle="modal"
                                data-target="#top-up-modal"
                                class="btn btn-outline-primary"
                                type="button"
                            >
                                <vue-feather type="plus" size="14" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue';
    import { closeModal, openModal } from '../../utilities/_helpers'
    import { useChatStore } from '../../stores/ChatStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import Clipboard from 'clipboard';
    import { BPopover } from 'bootstrap-vue-3'
    export default {
        name: 'ChatModal',
        components: {
            BPopover,
        },
        props: {
            id: String
        },
        setup(props) {
            return {
                closeModal: closeModal,
                openModal: openModal,
                chatStore: useChatStore(),
                localizationStore: useLocalizationStore(),
                disputeLetterStore: useDisputeLetterStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                newChat: ref(true)
            };
        },
        mounted() {
            const $this = this;
            $this.chatStore.psConversation = new PerfectScrollbar('.user-chats');
            var clipboard = new Clipboard('.copy-message');
            clipboard.on('success', function (e) {
                e.clearSelection();
                toastr.success('Copied!');
            });
            clipboard.on('error', function (e) {
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
        },
        created() {
        },
        methods: {
            sendMessage() {
                if (this.newChat == true) {
                    this.chatStore.newConversation();
                    this.newChat = false;
                }
                this.chatStore.sendMessage();
            }
        },
        beforeMount() {
            
        }
    };
</script>